// src/components/ui/LanguageSwitcher.jsx
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import './LanguageSwitcher.css';

function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const activeLanguage = i18n.resolvedLanguage || i18n.language;

  useEffect(() => {
    document.documentElement.lang = activeLanguage;
  }, [activeLanguage]);

  const changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
  };

  const getButtonClassName = (lng) => {
    const baseClass = 'language-switcher__button';
    return activeLanguage === lng
      ? `${baseClass} ${baseClass}--active`
      : baseClass;
  };

  return (
    <div className="language-switcher">
      <button
        type="button"
        onClick={() => changeLanguage('pl')}
        disabled={activeLanguage === 'pl'}
        className={getButtonClassName('pl')}
      >
        PL
      </button>
      <button
        type="button"
        onClick={() => changeLanguage('en')}
        disabled={activeLanguage === 'en'}
        className={getButtonClassName('en')}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher;
